import { TranslationCatalog } from './translations.types';

export const AUTH_PASSWORD_RESET_TRANSLATIONS: TranslationCatalog = {
  es: {
    'passwordReset.title': 'Nueva contraseña',
    'passwordReset.subtitle': 'Crea una contraseña segura para tu cuenta',
    'passwordReset.field.password': 'Contraseña',
    'passwordReset.field.confirmPassword': 'Confirmar contraseña',
    'passwordReset.cta': 'Actualizar contraseña',
    'passwordReset.ctaLoading': 'Actualizando...',
    'passwordReset.backToLogin': 'Volver al inicio de sesión',
    'passwordReset.notice.preview': 'Modo vista activo. Puedes revisar la interfaz sin depender del enlace del correo.',
    'passwordReset.notice.previewSuccess': 'Vista previa completada. El flujo real se activará cuando ingreses desde el enlace del correo.',
    'passwordReset.notice.invalidLinkRedirect': 'Serás redirigido a recuperación de contraseña en {seconds}s',
    'passwordReset.error.invalidForm': 'Revisa los campos e intenta nuevamente.',
    'passwordReset.error.passwordRequired': 'Ingresa una contraseña.',
    'passwordReset.error.passwordRules': 'La contraseña debe cumplir con los requisitos indicados.',
    'passwordReset.error.confirmRequired': 'Confirma tu contraseña.',
    'passwordReset.error.passwordMismatch': 'Las contraseñas no coinciden.',
    'passwordReset.error.invalidToken': 'El enlace de recuperación no es válido o ya expiró.',
    'passwordReset.error.resetFailed': 'No fue posible actualizar tu contraseña. Intenta de nuevo.',
    'passwordReset.error.serverError': 'No pudimos procesar la solicitud. Intenta más tarde.',
    'passwordReset.error.noConnection': 'No hay conexión con el servidor. Verifica tu red.',
    'passwordReset.passwordGuide.title': 'Tu contraseña debe cumplir:',
    'passwordReset.passwordRule.minLength': '8 caracteres mínimo',
    'passwordReset.passwordRule.uppercase': 'Al menos una mayúscula',
    'passwordReset.passwordRule.number': 'Al menos un número',
    'passwordReset.passwordRule.special': 'Al menos un carácter especial (! # $ % + / - ? @)',
    'passwordReset.passwordWarning.common': 'Esta contraseña es bastante común. Te recomendamos elegir una más segura.',
    'passwordReset.success.title': 'Contraseña actualizada',
    'passwordReset.success.body': 'Ya puedes iniciar sesión con tu nueva contraseña.',
    'passwordReset.invalidLink.title': 'El enlace ya no es válido',
    'passwordReset.invalidLink.body': 'Solicita un nuevo enlace de recuperación para continuar.',
    'passwordReset.logoAria': 'WeMatch',
    'passwordReset.password.show': 'Mostrar contraseña',
    'passwordReset.password.hide': 'Ocultar contraseña',
    'passwordReset.confirmPassword.show': 'Mostrar confirmación de contraseña',
    'passwordReset.confirmPassword.hide': 'Ocultar confirmación de contraseña',
  },
  en: {
    'passwordReset.title': 'New password',
    'passwordReset.subtitle': 'Create a secure password for your account',
    'passwordReset.field.password': 'Password',
    'passwordReset.field.confirmPassword': 'Confirm password',
    'passwordReset.cta': 'Update password',
    'passwordReset.ctaLoading': 'Updating...',
    'passwordReset.backToLogin': 'Back to log in',
    'passwordReset.notice.preview': 'Preview mode is active. You can review the interface without relying on the email link.',
    'passwordReset.notice.previewSuccess': 'Preview completed. The real flow will activate when you enter from the email link.',
    'passwordReset.notice.invalidLinkRedirect': 'You will be redirected to password recovery in {seconds}s',
    'passwordReset.error.invalidForm': 'Review the fields and try again.',
    'passwordReset.error.passwordRequired': 'Enter a password.',
    'passwordReset.error.passwordRules': 'The password must meet the listed requirements.',
    'passwordReset.error.confirmRequired': 'Confirm your password.',
    'passwordReset.error.passwordMismatch': 'Passwords do not match.',
    'passwordReset.error.invalidToken': 'The recovery link is not valid or has expired.',
    'passwordReset.error.resetFailed': 'We could not update your password. Please try again.',
    'passwordReset.error.serverError': 'We could not process the request. Please try again later.',
    'passwordReset.error.noConnection': 'There is no connection to the server. Check your network.',
    'passwordReset.passwordGuide.title': 'Your password must include:',
    'passwordReset.passwordRule.minLength': '8 characters minimum',
    'passwordReset.passwordRule.uppercase': 'At least one uppercase letter',
    'passwordReset.passwordRule.number': 'At least one number',
    'passwordReset.passwordRule.special': 'At least one special character (! # $ % + / - ? @)',
    'passwordReset.passwordWarning.common': 'This password is quite common. We recommend choosing a stronger one.',
    'passwordReset.success.title': 'Password updated',
    'passwordReset.success.body': 'You can now sign in with your new password.',
    'passwordReset.invalidLink.title': 'This link is no longer valid',
    'passwordReset.invalidLink.body': 'Request a new recovery link to continue.',
    'passwordReset.logoAria': 'WeMatch',
    'passwordReset.password.show': 'Show password',
    'passwordReset.password.hide': 'Hide password',
    'passwordReset.confirmPassword.show': 'Show password confirmation',
    'passwordReset.confirmPassword.hide': 'Hide password confirmation',
  },
};
